/**
 * Query params for Apple Purchase Linkout flow
 */
export const ORDER_UUID_KEY = "order_uuid";
export const BILLING_REMINDER_OPT_IN_KEY = "billing_reminder_opt_in";

/**
 * Page IDs for Apple Purchase Linkout flow
 */
export const LINKOUT_CHECKOUT_PAGE_ID = "linkoutCheckout";
export const LINKOUT_CONFIRMATION_PAGE_ID = "linkoutConfirmation";
